import { render, staticRenderFns } from "./parametrosDefecto.vue?vue&type=template&id=ad68c8d6&"
import script from "./parametrosDefecto.vue?vue&type=script&lang=js&"
export * from "./parametrosDefecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports